import React, { useEffect, useState } from 'react';
import Icon from '../Icon';
import { addOverlay, removeOverlay } from '../../Actions/Overlay.action';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { signOut } from '../../Actions/Login.action';
import { translate } from '../../Services/translation';

const LoggedInIconAndDropdown = () => {
  const [dropDownVisible, setDropDownVisible] = useState<boolean>(false);
  const dropdownRef = React.useRef<HTMLUListElement>(null);
  const dispatch = useDispatch();
  const navigation = useTypedSelector((state) => state.navigation);

  useEffect(() => {
    dropDownVisible
      ? dispatch(
          addOverlay(
            'mypages-menu-modal',
            () => setDropDownVisible && setDropDownVisible(false),
            0
          )
        )
      : dispatch(removeOverlay('mypages-menu-modal'));
  }, [dropDownVisible]);
  return (
    <div className="relative store-screen:hidden">
      <div
        onClick={() => setDropDownVisible(!dropDownVisible)}
        className="relative "
      >
        <button className="relative flex cursor-pointer px-2 py-3 lg:py-2 hover:[&_.icon]:scale-110">
          <Icon
            name="user"
            className="h-6 w-6 text-gray-700
        group-[.is-light-theme]:text-white"
          />
          <span className="absolute bottom-[3px] right-[3px] z-10 h-3 w-3 rounded-full bg-success-500"></span>
        </button>
      </div>
      {dropDownVisible && (
        <ul
          ref={dropdownRef}
          className="my-pages-menu absolute right-0 top-10 z-[100] min-w-[200px] overflow-hidden rounded border border-gray-300 bg-white"
        >
          {navigation.myPagesUrl && (
            <li className="border-b border-gray-300 px-3 py-2.5 text-md">
              <a href={navigation.myPagesUrl}>
                {translate('mypages-menu.my-details')}
              </a>
            </li>
          )}
          {navigation.myOrdersUrl && (
            <li className="border-b border-gray-300 px-3 py-2.5 text-md">
              <a href={navigation.myOrdersUrl}>
                {translate('mypages-menu.order-history')}
              </a>
            </li>
          )}
          <li
            className="flex flex-1 cursor-pointer items-center border-b border-gray-300 p-2 px-3 py-2.5 text-md "
            onClick={signOut}
          >
            <Icon name="logout" className="mr-2 h-5 w-5 text-error-500" />
            {translate('general.sign-out')}
          </li>
        </ul>
      )}
    </div>
  );
};

export default LoggedInIconAndDropdown;
